const RANGE_SEPARATOR = ' até '

const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
  'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

// Faixas fechadas, do primeiro ao último dia, como o filtro de contratos sempre abriu.
const PERIOD_PRESETS = [
  { key: 'month', label: 'Este mês' },
  { key: 'previousMonth', label: 'Mês anterior' },
  { key: 'quarter', label: 'Este trimestre' },
  { key: 'year', label: 'Este ano' },
]

const pad = number => String(number).padStart(2, '0')

const toYmd = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

const fromYmd = ymd => {
  const [year, month, day] = String(ymd || '').split('-').map(Number)
  return year && month && day ? new Date(year, month - 1, day) : null
}

const range = (start, end) => ({ startDate: toYmd(start), endDate: toYmd(end) })

function periodRange(value) {
  const [start, end] = String(value || '').split(RANGE_SEPARATOR).map(part => part.trim())
  return { startDate: start || null, endDate: end || start || null }
}

function toPeriodValue({ startDate, endDate }) {
  return `${startDate}${RANGE_SEPARATOR}${endDate}`
}

function presetRange(key, today = new Date()) {
  const year = today.getFullYear()
  const month = today.getMonth()

  if (key === 'previousMonth') {
    return range(new Date(year, month - 1, 1), new Date(year, month, 0))
  }
  if (key === 'quarter') {
    const firstMonth = month - (month % 3)
    return range(new Date(year, firstMonth, 1), new Date(year, firstMonth + 3, 0))
  }
  if (key === 'year') {
    return range(new Date(year, 0, 1), new Date(year, 11, 31))
  }
  return range(new Date(year, month, 1), new Date(year, month + 1, 0))
}

function shiftMonth(endDate, step, today = new Date()) {
  const base = fromYmd(endDate) || today
  const year = base.getFullYear()
  const month = base.getMonth() + step
  return range(new Date(year, month, 1), new Date(year, month + 1, 0))
}

function presetKeyOf(startDate, endDate, today = new Date()) {
  const preset = PERIOD_PRESETS.find(item => {
    const presetDates = presetRange(item.key, today)
    return presetDates.startDate === startDate && presetDates.endDate === endDate
  })
  return preset ? preset.key : null
}

function periodLabel(startDate, endDate, today = new Date()) {
  if (!startDate) return ''

  const presetKey = presetKeyOf(startDate, endDate, today)
  if (presetKey) {
    return PERIOD_PRESETS.find(item => item.key === presetKey).label
  }

  const start = fromYmd(startDate)
  const end = fromYmd(endDate)
  const isWholeMonth = start && end
    && start.getDate() === 1
    && start.getFullYear() === end.getFullYear()
    && start.getMonth() === end.getMonth()
    && end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()

  return isWholeMonth ? `${MONTHS[start.getMonth()]} ${start.getFullYear()}` : 'Personalizado'
}

module.exports = {
  PERIOD_PRESETS,
  periodLabel,
  periodRange,
  presetKeyOf,
  presetRange,
  shiftMonth,
  toPeriodValue,
}
